<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="12">
        <div>
          <!-- <v-btn
            class="ma-2"
            color="primary"
            outlined
            v-if=" selected.length == 1"
            @click="$router.push('/pump-perf-edit/'+selected[0].idpump)"
          >Edit</v-btn>-->

          <v-btn v-if=" selected.length > 1" text @click="deletePumpPerf" color="red">{{ $t('delete') }}</v-btn>

          <v-btn class="ma-2" color="primary" @click="$router.push('/pump-performance-add')">
            <v-icon left dark>mdi-plus</v-icon>{{$t('add_performance_data')}}
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-card>
        <v-card-title>
          {{$t('pump_performances')}}
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            :label="$t('search')"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>

        <v-data-table
          item-key="idpump_perf"
          :single-select="false"
          show-select
          v-model="selected"
          :headers="headers"
          :items="perfs"
          :search="search"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <!-- <v-toolbar-title> -->

              <v-col cols="12" md="5" sm="3">
                <v-select
                  width="200"
                  v-model="selectedPumpTypeId"
                  :items="pumpTypes"
                  :label="$t('pump.pump_type')"
                ></v-select>
              </v-col>
              <v-col cols="12" md="2" sm="3">
                <v-select width="200" v-model="selectedPumpStage" :items="pumpStages" :label="$t('pump.stage')"></v-select>
              </v-col>


              <!-- </v-toolbar-title> -->
              <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
              <v-spacer></v-spacer>
             

              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark class="mb-2" v-on="on">{{$t('new_item_data')}}</v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }} : {{ editedItem.model }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col v-if="editedIndex == -1" cols="12" md="7" sm="4">
                          <v-select
                            width="400"
                            v-model="selectedPumpTypeId"
                            :items="pumpTypes"
                            :label="$t('pump.pump_type')"
                          ></v-select>
                        </v-col>
                        <v-col v-if="editedIndex == -1" cols="12" md="3" sm="4">
                          <v-select
                            width="200"
                            v-model="editedItem.stage"
                            :items="pumpStages"
                            :label="$t('pump.stage')"
                          ></v-select>
                          <!-- <v-text-field v-model="editedItem.stage" label="Stage"></v-text-field> -->
                        </v-col>

                        <v-col cols="12" md="2" sm="4">
                          <v-text-field v-model="editedItem.frequency" suffix="Hz" :label="$t('pump.frequency')"></v-text-field>
                        </v-col>

                      </v-row>
                      <v-row>
                        <!-- <v-col cols="12" sm="6" md="4">
                          <v-text-field v-model="editedItem.stage" label="Stage"></v-text-field>
                        </v-col>-->

                        <v-col cols="12" sm="6" md="4">
                          <v-text-field v-model="editedItem.q" suffix="m3/h" label="Q"></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" md="4">
                          <v-text-field v-model="editedItem.hm" suffix="m" label="Hm"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field v-model="editedItem.effiency" suffix="%" label="Efficiency"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field v-model="editedItem.npshr" suffix="" label="NPSHR"></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">{{$t('cancel')}}</v-btn>
                    <v-btn color="blue darken-1" text @click="save">{{$t('save')}}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              
            </v-toolbar>
          </template>

          <template v-slot:item.action="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
            <v-icon small @click="deleteItem(item)">delete</v-icon>
          </template>
          <template v-slot:no-data>
            <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
          </template>
        </v-data-table>
      </v-card>
    </v-row>
    <v-row> 
      <v-container>
              <v-btn text small @click="deleteAllPerfForPump">
                <v-icon>mdi-delete</v-icon> {{ $t('delete-all-performances-for-this-pump-type-for-all-stages') }}</v-btn>
      </v-container>
    </v-row>
  </v-container>
</template>

<script>
// const API_URL = "http://localhost:9090/";

export default {
  name: "HelloWorld",
  data: () => ({
    token: "",
    pumps: [],
    dialog: false,
    pumpStages: [],
    selectedPumpStage: "",
    selectedPumpTypeId: "",
    selected: [],
    editPumpPerfId: 100,
    search: "",
    perfs: [],
    
    editedIndex: -1,
    editedItem: {
      idpump_perf: -1,
      stage: "",
      type: "",
      idpump: -1,
      q: 0,
      hm: 0,
      effiency: 0,
      npshr: 0,
      frequency: 0,
    },
    defaultItem: {
      idpump_perf: -1,
      model: "",
      idpump: -1,
      m3_h: 0,
      stage: 0,
      hm: 0,
      effiency: 0,
      npshr: 0,
      frequency: 0,
    },
    pumpTypes: [],
    pump: {
      idpump: -1,
      model: "XSP 20",
      material: "Stainless Steel",
      motorid: "10",
      nominal_diameter: "6",
      stage: 50,
      max_shaft_power: 100,
      p2: 70,
      diameter_outlet: 40,
      weight: 6,
      lp: 65
    }
  }),

  computed: {
    headers() { return [
      {
        text: this.$t('pump.pump_type'),
        align: "left",
        sortable: true,
        value: "type"
      },
      { text: this.$t('pump.stage'), value: "stage" },
      { text: "Q", value: "q" },
      { text: "Hm", value: "hm" },
      { text: this.$t('pump.efficiency'), value: "effiency" },
      { text: "NPSHR", value: "npshr" },
      { text: this.$t('pump.frequency'), value: "frequency" },
      { text: this.$t('actions'), value: "action", sortable: false }
    ]},
    formTitle() {
      return this.editedIndex === -1 ? this.$t('new_item_data') : this.$t('edit_item_data');
    },
    pumpTypeChanged() {
      return this.editedItem.type
    }
  },

  watch: {
    // pumpTypeChanged() {
    //   if (this.editedItem.type == null) return;
    //   if ( this.editedIndex == -1) return;
      
    //   this.selectedPumpStage = "";
    //   this.selectedPumpTypeId = this.editedItem.type
    //   this.fetchPumpStages(this.editedItem.type);
    // },
    dialog(val) {
      val || this.close();
    },
    selectedPumpTypeId(val) {
      if (val == null) return;
      this.selectedPumpStage = "";
      this.fetchPumpStages(val);
    },
    selectedPumpStage(val) {
      if (val != "")
        this.fetchPumpPerformances(this.selectedPumpTypeId, val);
    }
  },

  // created () {
  //     this.initialize()
  //   },

  mounted: function() {
    if(localStorage.token){
      this.token = localStorage.token
      this.$http.defaults.headers.common['Authorization'] = `Bearer ${this.token}` 
    }
    this.fetchPumpTypes();
  },
  methods: {
    deleteAllPerfForPump(){
      if ( confirm(this.$t('confirm_delete')) ){
      this.$http.get(this.$API_URL + "delete_all_perf_in_pump_type?pump_type_id=" + this.selectedPumpTypeId).then(result => {
          this.fetchPumpPerformances(this.selectedPumpTypeId, this.selectedPumpStage);
      });
      }
    },
    editItem(item) {
      this.editedIndex = this.perfs.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.selected = [item];
      this.deletePumpPerf();
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        // update
        // Object.assign(this.perfs[this.editedIndex], this.editedItem);
        this.savePumpData(true, this.editedItem);
      } else {
        // save new
        // this.perfs.push(this.editedItem);
        this.savePumpData(false, this.editedItem);
      }
    },

    deletePumpPerf: function() {
      confirm(this.$t('confirm_delete')) &&
        this.selected.forEach(this.deleteDataRequest);
      this.selected = [];
      // console.log("selected bosaltildi.");
    },
    deleteDataRequest: function(perf) {
      this.$http
        .get(this.$API_URL + "pump-perf-delete?idpump_perf=" + perf.idpump_perf)
        .then(result => {
          console.log(result.data);
          if (this.selected.length == 0) this.fetchPumpPerformances(this.selectedPumpTypeId, this.selectedPumpStage);
        });
    },
    fetchPumpPerformances: function(pumpTypeId, stage) {
      var query = "";
      if (pumpTypeId != null) query = "?pumptypeid=" + pumpTypeId;
      if (stage != null) query = query + "&stage=" + stage;

      this.$http.get(this.$API_URL + "pumps-perfs" + query).then(result => {
        this.perfs = result.data;
      });
    },

    fetchPumpStages: function(pumpTypeId) {
      this.pumpStages = [];
      console.log("fetchPumpStages for pumptype id: " + pumpTypeId);
      pumpTypeId = this.selectedPumpTypeId;
      var query = "";
      if (pumpTypeId != null) query = "?pumptypeid=" + pumpTypeId;

      this.$http.get(this.$API_URL + "pump-stages" + query).then(result => {
        result.data.forEach(pumpStage => {
          this.pumpStages.push({
            text: pumpStage.stage,
            value: pumpStage.stage
          });
        });

        this.selectedPumpStage = result.data[0].stage;
      });
    },

    fetchPumpTypes: function() {
      this.pumpTypes = [];
      this.$http.get(this.$API_URL + "pump_types").then(result => {
        result.data.forEach(pumpType => {
          this.pumpTypes.push({
            text: `${pumpType.type} ${pumpType.fi_e}" ${pumpType.fi_r}mm`,
            
            value: pumpType.idpump_type
          });
        });

        console.log(result.data);

        this.selectedPumpTypeId = result.data[0].idpump_type;
      });
    },

    fetchPumps: function() {
      this.pumps = [];
      this.$http.get(this.$API_URL + "pumps").then(result => {
        result.data.forEach(pump => {
          this.pumps.push({
            text: pump.model,
            value: pump.idpump,
            stage: pump.stage
          });
        });

        console.log(result.data);

        this.selectedPumpId = result.data[0].idpump;
      });
    },

    savePumpData: function(isUpdate, item) {
      var targetUrl = isUpdate == false ? "save_pump_perf" : "update_pump_perf";
      item.type = this.selectedPumpTypeId

      this.$http({
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        url: this.$API_URL + targetUrl,
        data: item
      })
        .then(response => {
          // console.log(response.data);
          if (isUpdate){
            this.close();
          } else {
            alert(this.$t('save_success'));
          }

          if (targetUrl == "save_pump_perf"){
              this.selectedPumpTypeId = item.type
              this.selectedPumpStage = item.stage
          } 

          this.fetchPumpPerformances(
              this.selectedPumpTypeId,
              this.selectedPumpStage
            );
            
          // if (response.data == "1")
          //  window.history.go(-1)
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>
